export const assignDefaultValue = (target, value) => {
    return target == undefined ? value : target;
};

export const arrayToObject = (arr, x, y) => {
    let obj = {};
    arr.forEach((e) => {
        obj[e[x]] = e[y];
    });
    return obj;
};

export const colorNames = {
    green: "#00C853",
    orange: "#FFA500",
    red: "#FF3D00",
    black: "#000",
    grey: "#636363",
};

export const statusToColor = (status) => {
    let color =
        status == "success"
            ? colorNames.green
            : status == "warning"
            ? colorNames.orange
            : status == "error"
            ? colorNames.red
            : colorNames.grey;
    return color;
};

// 轉換 Boolean 至 Icon (  )
// falseToDash: 將 false 轉換成 dash; 預設: false
export const boolToIcons = ({ value, falseToDash = false } = {}) => {
    return value ? "md-checkmark" : !falseToDash ? "md-close" : "md-remove";
};

// 轉換 Boolean 至 顏色
export const boolToColors = ({ value, falseToGrey = false } = {}) => {
    if (value == undefined) return colorNames.grey;
    return value ? colorNames.green : !falseToGrey ? colorNames.red : colorNames.grey;
};

export const validateValueLength = (target, length) => {
    if (target > length) return `字元長度限制為${length}`;
};
export const latencyToColorName = (latency = 0) => {
    let statusColorName =
        latency == 0
            ? colorNames.grey
            : latency <= 200
            ? colorNames.green
            : latency > 200 && latency <= 499
            ? colorNames.orange
            : colorNames.red;
    return statusColorName;
};

export const trendDirectionToColorName = (direction) => {
    let statusColorName =
        direction == ""
            ? colorNames.grey
            : direction == "positive"
            ? colorNames.green
            : direction == "negative"
            ? colorNames.red
            : colorNames.grey;
    return statusColorName;
};

export const trendDirectionToIcons = (direction) => {
    let iconName =
        direction == ""
            ? "ios-remove"
            : direction == "positive"
            ? "ios-arrow-down"
            : direction == "negative"
            ? "ios-arrow-up"
            : "ios-remove";
    return iconName;
};

export const outgoingRateToStatusName = (rate) => {
    let statusName = rate == 0 ? "default" : rate > 99 ? "success" : rate > 0 && rate < 60 ? "warning" : "error";
    return statusName;
};

export const switchStatusToI18n = (vm, status) => {
    switch (status) {
        case "運行中":
            return `${vm.$i18n.t("rcmtable.statusRunningText")}`;
            break;
        case "部署中":
            return `${vm.$i18n.t("rcmtable.statusDeployingText")}`;
            break;
        case "驗證中":
            return `${vm.$i18n.t("rcmtable.statusValidatingText")}`;
            break;
        case "刪除中":
            return `${vm.$i18n.t("rcmtable.statusRemovingText")}`;
            break;
        default:
            return status;
    }
};

export const wafRuleToIcon = (action) => {
    var imgPath =
        action == "Allow"
            ? "allow"
            : action == "Deny"
            ? "deny"
            : action == "Block Period"
            ? "block"
            : action == "Speed Limit"
            ? "speed"
            : action == "Gesture Challenge"
            ? "gesture"
            : "redirect";
    return imgPath;
};

export const generateHtmlPreview = (options) => {
    const { htmlPageRaw, ridPosition, ridColor } = options;
    return `
        <div class="htmlPageRawContainer">
        ${htmlPageRaw} 
        </div>
        <div class='rid'>
          <p>Case ID: 123456</p>
          <p>Time Stamp: 2020-01-01</p>
          <p>IP: 1.2.3.4</p>
        </div>
        <style>
          body {
            position: relative
          } 
          .rid {
            ${ridPosition}
            ${ridColor}
          }
          .htmlPageRawContainer {
            min-height: 300px
          }
        </style>`;
};

export const formItemCompletion = (formItem) => {
    let defaultFormItemOptions = {
        description: "<p></p>",
        isFormSlot: false,
        formTypes: [],
        options: [],
        optionStyle: 1,
        queryParamsFields: [],
        disabledOptions: [],
        selectAllowCreate: false,
        disabled: () => false,
        multiSelectWithToolbox: false,
        withOptionGroup: false,
        vShowFieldVal: () => {
            return 1;
        },
        watchField: () => {
            return 1;
        },
        sectionKey: "essential",
    };
    let finalFormItem = Object.assign(defaultFormItemOptions, formItem);
    return finalFormItem;
};

export const columnItemCompletion = (columnItem, data) => {
    // 將頁面給定的初始排序欄位 曬到column
    let sortObj = data.sort[0];
    if (sortObj[columnItem.key] !== undefined) {
        columnItem.sortType = sortObj[columnItem.key].order;
    }

    let defaultColumnItemOptions = {
        key: "",
        title: "",
        showInTable: "",
        width: "",
        tooltip: "",
        render: "",
        sortable: true,
        type: "",
        minWidth: 160,
        exportOptions: { canExport: true, callback: (value) => value },
        // maxWidth: 400
    };
    let finalColumnItem = Object.assign(defaultColumnItemOptions, columnItem);
    return finalColumnItem;
};

export const filterItemCompletion = (filterObject) => {
    let defaultFormRenderMapping = {
        string: "FormInput",
        boolean: "FormBoolean",
        select: "FormSelect",
        date: "FormDatePicker",
        range: "FormRange",
        number: "FormInput",
        object: "FormInput",
    };

    let defaultValMapping = {
        string: "",
        select: "",
        boolean: "",
        date: ["", ""],
        range: { gt: null, lt: null },
        number: "",
        object: "",
    };

    let formRender = defaultFormRenderMapping[filterObject.type];
    let value =
        filterObject.defaultValue !== undefined ? filterObject.defaultValue : defaultValMapping[filterObject.type];

    let defaultFilterItemOptions = {
        type: "string",
        formRender: formRender,
        value: value,
        multiple: false,
        options: [],
    };
    let finalFilterObject = Object.assign(defaultFilterItemOptions, filterObject);
    return finalFilterObject;
};

export const batchStepDataCompletion = (batchStepData) => {
    let defaultBatchStepData = {
        title: "Batch Step Title",
        content: "Batch Step Content",
        enter: () => {},
        beforeNextStep: () => {},
        validateBeforeNextStep: () => true,
        isNextBtnDisabled: () => false,
    };
    let finalBatchStepData = Object.assign(defaultBatchStepData, batchStepData);
    return finalBatchStepData;
};

import { _dateFormat } from "@/libs/dateformat.js";
export const vueTextFilters = {
    arrayToString: function (text) {
        return Array.isArray(text) ? text.join(", ") : text;
    },
    dateFormat: function (text, format) {
        return text ? _dateFormat(text, format) : "";
    },
};

export const queryParamsFieldsCompletion = (queryParamsFields) => {
    let completeQueryParamsFields = queryParamsFields.map((field) => {
        let item = {};
        // 使用者直接給value, 沒有其他附加選項
        if (typeof field == "string") {
            item.fieldName = field;
        } else {
            item = field;
        }

        // 缺失 fieldName 警告
        if (!item.fieldName) {
            console.log(`${JSON.stringify(field)} missing fieldName`);
        }

        // 補全
        let defaultOptions = {
            fieldName: "",
            queryIf: (value) => true,
        };
        let finalItem = Object.assign(defaultOptions, item);

        return finalItem;
    });
    return completeQueryParamsFields;
};



// WEBPACK FOOTER //
// ./src/libs/rcmTableFieldsFunction.js